/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui';


/* ++++++++++ --------------- CHANGE BADGE : STYLES --------------- ++++++++++ */
export default {
    articlecard: {
      display: 'flex',
      flexDirection: 'column',
      borderRadius: pxToEm(16),
      rowGap: 0,
      background: '#F7F8FC',
      width: pxToEm(220),
      minWidth: pxToEm(220),
      height: pxToEm(250),
      fontFamily: '"Work Sans", sans-serif;',
      fontSize: pxToEm(12),
      border: '2px solid #F8F8F8',
      '& .featuredicon': {
        background: '#fb4106',
        width: '18px',
        height: '18px',
        borderRadius: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      '&.featured': {
        '& img': {
          flex: 1,
          maxHeight: '100%',
          height: 'auto'
        },
        '& .articlecardinfo': {
          flex: 1
        },
        '& .titlewrap': {
          fontSize: '15px'
        }
      },
      '&.horizontal': {
        flexDirection: 'row',
        width: pxToEm(320),
        minWidth: pxToEm(320),
        minHeight: pxToEm(92),
        height: '100%',
        '& img, & .imageplaceholder': {
          borderTopLeftRadius: pxToEm(14),
          borderBottomLeftRadius: pxToEm(14),
          borderTopRightRadius: 0,
          borderRight: '2px solid #000',
          borderBottom: 0,
          minWidth: pxToEm(160),
          minHeight: '92px',
          flex: 1
        },
        '& .statswrapper': {
          top: 0,
          left: 0,
          height: 'auto',
          padding: 0,
          alignItems: 'center',
          minHeight: pxToEm(24)
        },
        '& .titlewrap': {
          top: 0,
          width: '100%',
          padding: 0
        },
        '& .articlecardinfo': {
          justifyContent: 'center',
          margin: pxToEm(8),
          gap: pxToEm(8)
        },
        '& .viewscounter': {
          padding: 0
        }
      },
      '& .articlecardinfo': {
        display: 'flex',
        flexDirection: 'column',
        columnGap: pxToEm(8),
        flex: 1
      },
      '& .titlewrap': {
        padding: `0 ${pxToEm(16)}`,
        minHeight: pxToEm(56),
        boxSizing: 'border-box',
        position: 'relative',
        top: pxToEm(18),
        display: '-webkit-box',
        '-webkit-line-clamp': 3,
        '-webkit-box-orient': 'vertical',
        overflow: 'hidden',
        fontWeight: 500,
        '& .placeholder': {
          background: '#EEEFF1',
          height: pxToEm(10),
          borderRadius: pxToEm(8),
          width: '100%'
        }
      },
      '& img': {
        background: '#F8F8F8',
        borderTopLeftRadius: pxToEm(14),
        borderTopRightRadius: pxToEm(14),
        objectFit: 'cover',
        height: '50%',
        maxHeight: pxToEm(125),
        borderBottom: '2px solid #000',
        flex: 1
      },
      '& .imageplaceholder': {
        background: '#EEEFF1',
        width: '100%',
        borderBottom: '1px solid #000',
        flex: '100%',
        height: 'auto',
        borderTopLeftRadius: pxToEm(14),
        borderTopRightRadius: pxToEm(14)
      },
      '& .roundicontext': {
        display: 'flex',
        background: '#FFFFFF',
        color: '#000',
        borderRadius: pxToEm(32),
        boxShadow: '0px 1px 5px 0px rgba(0, 0, 0, 0.15)',
        padding: `${pxToEm(4)} ${pxToEm(8)}`,
        height: pxToEm(26),
        maxHeight: pxToEm(26),
        alignItems: 'center',
        justifyContent: 'center',
        boxSizing: 'border-box',
        gap: pxToEm(4),
        fontWeight: 500
      },
      '& .statswrapper': {
        display: 'flex',
        gap: pxToEm(8),
        position: 'relative',
        top: pxToEm(-14),
        left: pxToEm(8),
        height: 0
      },
      '& .roundicontext svg': {
        height: pxToEm(16),
        width: pxToEm(16)
      },
      '& .coolmedialogo': {
        background: '#061240',
        height: pxToEm(125),
        maxHeight: pxToEm(125),
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        borderTopLeftRadius: pxToEm(14),
        borderTopRightRadius: pxToEm(14),
        '& svg': {
          opacity: '0.5',
          height: pxToEm(72),
          width: pxToEm(72)
        }
      },
      '& .viewscounter': {
        display: 'flex',
        gap: pxToEm(8),
        alignItems: 'center',
        color: '#5566aa',
        padding: `0 ${pxToEm(16)}`,
        marginBottom: pxToEm(8),
        '& svg': {
          width: pxToEm(16),
          height: pxToEm(16),
         '& path': {
           fill: '#5566aa'
         }
        }
      },
      '& .titleviewwrap': {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%'
      }
    }
}
